import { Frame, Loading } from '@shopify/polaris';
import React from 'react';

function PageLoading() {
  return (
    <Frame>
      <Loading />
    </Frame>
  )
}

export default PageLoading;
